import * as React from 'react'
import { FC } from 'react'
import { BulkActions } from './typings'
import {
  GridApi,
  useGridSelector,
  selectedGridRowsSelector,
} from '@mui/x-data-grid-pro'
import Box from '@mui/material/Box'

export const BulkActionsToolbar: FC<{
  apiRef: React.MutableRefObject<GridApi>
  BulkActions: BulkActions
}> = (props) => {
  const { apiRef, BulkActions } = props

  const selectedRows = useGridSelector(apiRef, selectedGridRowsSelector)

  return (
    <Box
      width="100%"
      height="auto"
      style={{ backgroundColor: '#f9fcff' }}
      px={2}
      py={1}
    >
      <BulkActions selectedRows={selectedRows} />
    </Box>
  )
}
BulkActionsToolbar.displayName = 'BulkActionsToolbar'
